// ============================================
// Enums and Constants
// ============================================
// Lead Status - follows sales funnel progression
export const LEAD_STATUS = {
    NEW: 'new',
    CONTACTED: 'contacted',
    QUALIFIED: 'qualified',
    UNQUALIFIED: 'unqualified',
    CONVERTED: 'converted',
};
// Lead Source - where leads come from
export const LEAD_SOURCE = {
    WEBSITE: 'website',
    REFERRAL: 'referral',
    COLD_CALL: 'cold_call',
    TRADE_SHOW: 'trade_show',
    PARTNER: 'partner',
    OTHER: 'other',
};
// Account Type
export const ACCOUNT_TYPE = {
    PROSPECT: 'prospect',
    CUSTOMER: 'customer',
    PARTNER: 'partner',
    COMPETITOR: 'competitor',
};
// Account Industry - Maldives hospitality supply focused
export const INDUSTRY = {
    HOTEL: 'hotel',
    RESORT: 'resort',
    GUESTHOUSE: 'guesthouse',
    SAFARI_VESSEL: 'safari_vessel',
    CRUISE: 'cruise',
    RESTAURANT: 'restaurant',
    GOVERNMENT: 'government',
    HEALTHCARE: 'healthcare',
    RETAIL: 'retail',
    CORPORATE: 'corporate',
    DISTRIBUTOR: 'distributor',
    OTHER: 'other',
};
// Opportunity Stage - follows sales pipeline
export const OPPORTUNITY_STAGE = {
    QUALIFICATION: 'qualification',
    NEEDS_ANALYSIS: 'needs_analysis',
    PROPOSAL: 'proposal',
    NEGOTIATION: 'negotiation',
    CLOSED_WON: 'closed_won',
    CLOSED_LOST: 'closed_lost',
};
// Stage probabilities for weighted pipeline
export const STAGE_PROBABILITIES = {
    qualification: 10,
    needs_analysis: 25,
    proposal: 50,
    negotiation: 75,
    closed_won: 100,
    closed_lost: 0,
};
// User Roles
export const USER_ROLE = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    MANAGER: 'manager',
    USER: 'user',
};
// Tenant user roles
export const TENANT_USER_ROLE = {
    MANAGER: 'manager',
    USER: 'user',
};
// Tenant status values
export const TENANT_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
};
// Allowed status transitions for leads
export const LEAD_STATUS_TRANSITIONS = {
    new: ['contacted', 'unqualified'],
    contacted: ['qualified', 'unqualified'],
    qualified: ['converted', 'unqualified'],
    unqualified: ['new'], // Can reopen
    converted: [], // Terminal state
};
// Allowed stage transitions for opportunities
export const OPPORTUNITY_STAGE_TRANSITIONS = {
    qualification: ['needs_analysis', 'closed_lost'],
    needs_analysis: ['proposal', 'qualification', 'closed_lost'],
    proposal: ['negotiation', 'needs_analysis', 'closed_lost'],
    negotiation: ['closed_won', 'closed_lost', 'proposal'],
    closed_won: [], // Terminal state
    closed_lost: ['qualification'], // Can reopen
};
//# sourceMappingURL=enums.js.map